import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class QueryParamsService {
  private readonly redirectParamsToStrip = ['tests', 'tests[]', 'panel', 'panel[]', 'reorderId'];

  /**
   * Binds the specified query parameters to the given base URL.
   *
   * @param {string} baseUrl the base URL to which the query parameters will be added
   * @param {Record<string, string>} queryParams the query parameters to be appended to the base URL
   *
   * @returns {string} the base URL with the query parameters appended
   */
  public readonly bindQueryParamsToUrl = (baseUrl: string, queryParams: Record<string, string>): string =>
    `${baseUrl}?${new URLSearchParams(queryParams).toString()}`;

  /**
   * Persists query parameters from the current URL when redirecting to another page.
   *
   * @param {string} baseUrl the URL to redirect to
   * @param {string} currentUrl the URL containing the query parameters to persist
   *
   * @returns {string} the redirect URL with the persisted query parameters appended
   */
  public readonly buildRedirectWithPersistedParams = (baseUrl: string, currentUrl: string): string => {
    const source = new URL(currentUrl);
    const target = new URL(baseUrl);
    const processedKeys = new Set<string>();

    source.searchParams.forEach((value, key) => {
      if (!this.redirectParamsToStrip.includes(key)) {
        if (!processedKeys.has(key)) {
          target.searchParams.delete(key);
          processedKeys.add(key);
        }

        target.searchParams.append(key, value);
      }
    });

    return target.toString();
  };
}
